import React from 'react';
import { RocketIcon } from 'lucide-react';
const SignupEmbed = () => {
  return <section id="signup" className="py-20 bg-gradient-to-br from-purple-50 via-indigo-50 to-blue-50" data-id="element-2198">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2199">
        <div className="text-center mb-12" data-id="element-2200">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-purple-600 to-indigo-600 rounded-2xl mb-6" data-id="element-2201">
            <RocketIcon className="h-8 w-8 text-white" data-id="element-2202" />
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-2203">
            Start Building Your AI Agent Today
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-2204">
            Sign up now and create your first AI shopping assistant in minutes.
            No credit card required.
          </p>
        </div>

        <div className="max-w-5xl mx-auto" data-id="element-2205">
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-200" data-id="element-2206">
            {/* Embedded Signup Page */}
            <div className="relative w-full" style={{
            height: '800px'
          }} data-id="element-2207">
              <iframe src="https://chat.shopilots.com/signup" title="Shopilots Signup" className="absolute inset-0 w-full h-full" frameBorder="0" allow="clipboard-write" data-id="element-2208"></iframe>
            </div>
          </div>

          {/* Trust Indicators */}
          <div className="mt-8 flex flex-wrap justify-center items-center gap-8 text-sm text-gray-600" data-id="element-2209">
            <div className="flex items-center" data-id="element-2210">
              <svg className="h-5 w-5 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20" data-id="element-2211">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-2212" />
              </svg>
              <span data-id="element-2213">Free to start</span>
            </div>
            <div className="flex items-center" data-id="element-2214">
              <svg className="h-5 w-5 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20" data-id="element-2215">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-2216" />
              </svg>
              <span data-id="element-2217">No credit card required</span>
            </div>
            <div className="flex items-center" data-id="element-2218">
              <svg className="h-5 w-5 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20" data-id="element-2219">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-2220" />
              </svg>
              <span data-id="element-2221">Setup in 5 minutes</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default SignupEmbed;